import React, { useEffect, useState } from "react";

import { Col, Row } from "react-bootstrap";
import FormSelect from "app/Components/_form/FormSelect/FormSelect";
import { ButtonsContainer } from "../../IncidentReportForm";
import FormInput from "app/Components/_form/FormInput/FormInput";
import FormCheckbox from "app/Components/_form/FormCheckbox/FormCheckbox";
import FormTextArea from "app/Components/_form/FormTextArea/FormTextArea";
import InputError from "app/Components/_form/InputError/InputError";
import YesOrNo from "app/_pages/_healthSafetyEnvironment/YesOrNo.component";
import { GENERAL_REASONS, incidentTypes, RO_CLOSED_INCIDENT_TYPE } from "../../CONSTANTS";
function GeneralInfoTab({ form = {}, onChange, error = {}, setTab, onSubmit }) {
  const [isAnyChecked, setIsAnyChecked] = useState(false);

  useEffect(() => {
    let checkBoxKeys = GENERAL_REASONS.map((d) => d.id);
    let flag = 0;
    checkBoxKeys.forEach((key) => {
      if (form[key]) flag++;
    });
    if (flag) setIsAnyChecked(true);
    else setIsAnyChecked(false);
  }, [
    form.fireInvolved,
    form.inundation,
    form.fallOfObject,
    form.facilityOutage,
    form.permanentDisability,
    form.facilityShutdown,
    form.explosion,
    form.longDurationFire,
    form.equipmentFailure,
    form.alcoholViolator,
    form.ppeViolator,
    form.unfitBuyerTruck,
    form.unfitHEMM,
  ]);
  return (
    <div className="card p-3 pb-0 mt-3">
      <div className="simple-card-title">
        <h3 class="text-capitalize mb-0">General Info</h3>
      </div>
      <div className="ehsFormWrapper">
        <Row className="pt-1">
          <Col lg={3}>
            {/* <label className="checkbox checkbox-primary mb-3">
              <input
                type="checkbox"
                name="fireInvolved"
                checked={form.fireInvolved}
                onChange={onChange}
              />
              <span>Fire Involved</span>
              <span className="checkmark" />
            </label> */}
            <FormCheckbox
              type="checkbox"
              name="fireInvolved"
              checked={form.fireInvolved}
              onChange={onChange}
              label={"Fire Involved"}
              disabled={isAnyChecked && !form.fireInvolved}
            />
          </Col>
          <Col lg={3}>
            {/* <label className="checkbox checkbox-primary mb-3">
              <input
                type="checkbox"
                name="facilityOutage"
                checked={form.facilityOutage}
                onChange={onChange}
              />
              <span>Whether plant shut down caused Outage of the Facility</span>
              <span className="checkmark" />
            </label> */}
            <FormCheckbox
              type="checkbox"
              name="facilityOutage"
              checked={form.facilityOutage}
              onChange={onChange}
              label={"Electrical Shock"}
              disabled={isAnyChecked && !form.facilityOutage}
            />
          </Col>
          <Col lg={3}>
            {/* <label className="checkbox checkbox-primary mb-3">
              <input
                type="checkbox"
                name="permanentDisability"
                checked={form.permanentDisability}
                onChange={onChange}
              />
              <span>
                Fatality/permanent loss of body part or permanent disability
              </span>
              <span className="checkmark" />
            </label> */}
            <FormCheckbox
              type="checkbox"
              name="permanentDisability"
              checked={form.permanentDisability}
              onChange={onChange}
              label={"Lighting"}
              disabled={isAnyChecked && !form.permanentDisability}
            />
          </Col>
          <Col lg={3}>
            {/* <label className="checkbox checkbox-primary mb-3">
              <input
                type="checkbox"
                name="facilityShutdown"
                checked={form.facilityShutdown}
                onChange={onChange}
              />
              <span>Shutdown of plant/facility</span>
              <span className="checkmark" />
            </label> */}
            <FormCheckbox
              type="checkbox"
              name="facilityShutdown"
              checked={form.facilityShutdown}
              onChange={onChange}
              label={"Due to moving equipment"}
              disabled={isAnyChecked && !form.facilityShutdown}
            />
          </Col>
          <Col lg={3}>
            {/* <label className="checkbox checkbox-primary mb-3">
              <input
                type="checkbox"
                name="explosion"
                checked={form.explosion}
                onChange={onChange}
              />
              <span>Blow out or explosion</span>
              <span className="checkmark" />
            </label> */}
            <FormCheckbox
              type="checkbox"
              name="explosion"
              checked={form.explosion}
              onChange={onChange}
              label={"Explosive Involved"}
              disabled={isAnyChecked && !form.explosion}
            />
          </Col>
          <Col lg={3}>
            {/* <label className="checkbox checkbox-primary mb-3">
              <input
                type="checkbox"
                name="longDurationFire"
                checked={form.longDurationFire}
                onChange={onChange}
              />
              <span>Fire more than 15 minutes duration</span>
              <span className="checkmark" />
            </label> */}
            <FormCheckbox
              type="checkbox"
              name="longDurationFire"
              checked={form.longDurationFire}
              onChange={onChange}
              label={"Fall from height"}
              disabled={isAnyChecked && !form.longDurationFire}
            />
          </Col>
          <Col lg={3}>
            {/* <label className="checkbox checkbox-primary mb-3">
              <input
                type="checkbox"
                name="equipmentFailure"
                checked={form.equipmentFailure}
                onChange={onChange}
              />
              <span>Failure of rig critical equipment like draw-works</span>
              <span className="checkmark" />
            </label> */}
            <FormCheckbox
              type="checkbox"
              name="equipmentFailure"
              checked={form.equipmentFailure}
              onChange={onChange}
              label={"Vehicle Collision/toppling"}
              disabled={isAnyChecked && !form.equipmentFailure}
            />
          </Col>
          <Col lg={3}>
            {/* <label className="checkbox checkbox-primary mb-3">
              <input
                type="checkbox"
                name="equipmentFailure"
                checked={form.equipmentFailure}
                onChange={onChange}
              />
              <span>Failure of rig critical equipment like draw-works</span>
              <span className="checkmark" />
            </label> */}
            <FormCheckbox
              type="checkbox"
              name="fallOfObject"
              checked={form.fallOfObject}
              onChange={onChange}
              label={"Fall of object"}
              disabled={isAnyChecked && !form.fallOfObject}
            />
          </Col>
          <Col lg={3}>
            {/* <label className="checkbox checkbox-primary mb-3">
              <input
                type="checkbox"
                name="equipmentFailure"
                checked={form.equipmentFailure}
                onChange={onChange}
              />
              <span>Failure of rig critical equipment like draw-works</span>
              <span className="checkmark" />
            </label> */}
            <FormCheckbox
              type="checkbox"
              name="inundation"
              checked={form.inundation}
              onChange={onChange}
              label={"Inundation"}
              disabled={isAnyChecked && !form.inundation}
            />
          </Col>
          <Col lg={3}>
            <FormCheckbox
              type="checkbox"
              name="alcoholViolator"
              checked={form.alcoholViolator}
              onChange={onChange}
              label={"Alcohol Violator"}
              disabled={isAnyChecked && !form.alcoholViolator}
            />
          </Col>
          <Col lg={3}>
            <FormCheckbox
              type="checkbox"
              name="ppeViolator"
              checked={form.ppeViolator}
              onChange={onChange}
              label={"PPE Violator"}
              disabled={isAnyChecked && !form.ppeViolator}
            />
          </Col>
          <Col lg={3}>
            <FormCheckbox
              type="checkbox"
              name="unfitBuyerTruck"
              checked={form.unfitBuyerTruck}
              onChange={onChange}
              label={"Unfit Buyer's Truck"}
              disabled={isAnyChecked && !form.unfitBuyerTruck}
            />
          </Col>
          <Col lg={3}>
            <FormCheckbox
              type="checkbox"
              name="unfitHEMM"
              checked={form.unfitHEMM}
              onChange={onChange}
              label={"Unfit HEMM"}
              disabled={isAnyChecked && !form.unfitHEMM}
            />
          </Col>
        </Row>
        {/* {console.log("form value is ",form)}; */}
        <Row>
          <Col lg={4}>
            {/* <div className="form-group">
              <label>Indirect Losses</label>
              

              <SimpleSelect
                name="indirectLosses"
                value={form.indirectLosses}
                onChange={onChange}
                
                options={["Through put", "Production Loss"]}
                init="Select"
                array="single"
              ></SimpleSelect>

              <span className="small text-danger">
                {error.indirectLosses}
              </span>
            </div> */}
            <FormSelect
              name="indirectLosses"
              value={form.indirectLosses}
              onChange={onChange}
              //
              options={["Throughput", "Production Loss"]}
              blankSelect="Select"
              array="single"
              label={"Indirect Losses"}
              error={error?.indirectLosses}
            ></FormSelect>
          </Col>
          <Col lg={4}>
            {/* <div className="form-group">
              <label>Status of the Facility</label>
              <SimpleSelect
                name="facilityStatus"
                value={form.facilityStatus}
                onChange={onChange}
                
                options={[
                  "Construction",
                  "Commissioning",
                  "Operation",
                  "Shutting down",
                  "Turn around",
                  "Maintenance",
                  "Start-up",
                  "Other",
                ]}
                init="Select"
                array="single"
              ></SimpleSelect>
              <span className="small text-danger">
                {error.facilityStatus}
              </span>
            </div> */}
            <FormSelect
              name="facilityStatus"
              value={form.facilityStatus}
              onChange={onChange}
              options={["Operating", "Shutdown", "Maintainance"]}
              init="Select"
              array="single"
              label={"Mine - Activity Operations Status"}
              error={error?.facilityStatus}
            ></FormSelect>
          </Col>
          <Col lg={4}>
            {/* <div className="form-group">
              <label>
                Whether similar incident happened in past at same location
              </label>

              <SimpleSelect
                name="similarIncidentHappened"
                value={form.similarIncidentHappened}
                onChange={onChange}
                
                options={["Yes", "No", "Not Aware"]}
                init="Select"
                array="single"
              ></SimpleSelect>
              <span className="small text-danger">
                {error.similarIncidentHappened}
              </span>
            </div> */}
            <FormSelect
              name="similarIncidentHappened"
              value={form.similarIncidentHappened}
              onChange={onChange}
              options={["Yes", "No", "Not Aware"]}
              init="Select"
              array="single"
              label={"Whether similar incident happened in the past at same location"}
              error={error?.similarIncidentHappened}
            ></FormSelect>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            {/* <div className="form-group">
              <label>Incident - Short Summary</label>
              <input
                name="summary"
                value={form.summary}
                onChange={onChange}
                type="text"
                class="form-control"
                placeholder=""
              />
              <span className="small text-danger">{error.summary}</span>
            </div> */}
            <FormInput
              name="summary"
              value={form.summary}
              onChange={onChange}
              type="text"
              class="form-control"
              placeholder=""
              label={"Incident Short Summary"}
              error={error?.summary}
            />
          </Col>
          <Col lg={6}>
            {/* <div className="form-group">
              <label>Incident - Detailed Description</label>
              <textarea
                name="description"
                value={form.description}
                onChange={onChange}
                class="form-control h-120"
              />
              <span className="small text-danger">{error.description}</span>
            </div> */}
            <FormTextArea
              name="description"
              value={form.description}
              onChange={onChange}
              className="form-control h-120"
              label={"Incident - Detailed Description"}
              error={error?.description}
            />
          </Col>
          <Col lg={6}>
            {/* <div className="form-group">
              <label>Immediate measures/actions taken, if any</label>
              <textarea
                name="measuresOrActions"
                value={form.measuresOrActions}
                onChange={onChange}
                class="form-control h-120"
              />
              <span className="small text-danger">
                {error.measuresOrActions}
              </span>
            </div> */}
            <FormTextArea
              name="measuresOrActions"
              value={form.measuresOrActions}
              onChange={onChange}
              className="form-control h-120"
              label={"Immediate Measures/Action Taken (Do not enter CAPA here)"}
              error={error?.measuresOrActions}
            />
          </Col>
        </Row>
        {form?.severity &&
          RO_CLOSED_INCIDENT_TYPE.includes(form?.type) &&
          form?.severity < 4 && (
            <Row>
              <Col lg={12} className="text-center">
                {/* <div className="centerCheckbox">
                <FormCheckbox
                  type="checkbox"
                  name="closeIncident"
                  checked={form?.severity < 4 ? form.closeIncident : false}
                  onChange={form?.severity < 4 ? onChange : void 0}
                  label={"Close This Incident"}
                />
              </div> */}
                <div className="centerCheckbox">
                  <YesOrNo
                    title="Close This Incident"
                    name="closeIncident"
                    value={form.closeIncident ? form.closeIncident : false}
                    onChange={onChange}
                  />
                </div>
              </Col>
            </Row>
          )}
      </div>
      <ButtonsContainer
        incidentStatus={form.incidentStatus}
        setTab={setTab}
        closeIncident={form.closeIncident}
        prev={1}
        next={3}
        onSubmit={onSubmit}
      />
    </div>
  );
}

export default GeneralInfoTab;
